import Appointment from '../../Common/Appointment/Appointment';
import Quoter from './Quoter';
import AboutMe from './AboutMe';
import PreQuote from './PreQuote';
import MyHealthProfile from '../../Common/MyHealthProfile';
import Background from '../../Common/Background';
import TobaccoUse from '../../Common/TobaccoUse';
import ThankYou from '../../Common/ThankYou';
import Adventures from '../../Common/Adventures';
import DrivingRecord from '../../Common/DrivingRecord';
import FamilyHistory from '../../Common/FamilyHistory';
import MedicalDetails from '../../Common/MedicalDetails';
import MedicalHistory from '../../Common/MedicalHistory';
import AlcoholDrugAbuse from '../../Common/AlcoholDrugAbuse';
import InsuranceRequest from '../../Common/InsuranceRequest/InsuranceRequest';
import Bestow from '../../Common/InsuranceRequest/Bestow';
import Haven from '../../Common/InsuranceRequest/Haven';
import Lga from '../../Common/InsuranceRequest/Lga';

export {
  AboutMe,
  PreQuote,
  MyHealthProfile,
  Background,
  TobaccoUse,
  Quoter,
  Appointment,
  ThankYou,
  Adventures,
  DrivingRecord,
  FamilyHistory,
  MedicalDetails,
  MedicalHistory,
  AlcoholDrugAbuse,
  InsuranceRequest,
  Bestow,
  Haven,
  Lga,
}



// WEBPACK FOOTER //
// ./src/components/Quoters/MCT/steps/index.js